// extracted by mini-css-extract-plugin
export default {"inputsWrap":"InputsWrap_inputsWrap__V54Na","inputItem":"InputsWrap_inputItem__AuYvl","makeRedText":"InputsWrap_makeRedText__ExpVI","makeRedBorder":"InputsWrap_makeRedBorder__NmZfp"};